import React from 'react';
import css from './NewListingCard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';

function decodeHtml(html) {
  var doc = new DOMParser().parseFromString(html, 'text/html');
    var text = doc.documentElement.textContent;
      return new DOMParser().parseFromString(text, 'text/html').documentElement.textContent;
}

function stripHtmlTags(html) {
  return html.replace(/<[^>]*>/g, '');
}

export default function NewListingCard(props) {
  const { price, title, imgUrl, dashboardEvents, per, desc } = props;

  return (
    <div className={classNames(css.base)}>
      <div className={css.image}>
        <img alt={'listing'} src={imgUrl} />
        <div className={css.price}>
          ${price?.toLocaleString()} {per && `/ ${per.charAt(0)}`}
        </div>
      </div>
      <div className={classNames(css.content, 'min-h-[130px]')}>
        <div className={css.title}>{title}</div>
        <div className={css.description}>{stripHtmlTags(decodeHtml(desc))}</div>
      </div>

      <div className={css.line} />
      <div className={css.actions}>
        {/* Primary actions (left) — text + icon, V-Coach purple, matches Programs Edit/Sessions */}
        <div>
          {dashboardEvents
            ?.filter(x => !!x.isLeft)
            ?.map((item, idx) => {
              return (
                <div
                  key={`l-${idx}`}
                  onClick={item.onClick}
                  className={css.actionPrimary}
                >
                  <FontAwesomeIcon icon={item.icon} /> {item.name}
                </div>
              );
            })}
        </div>

        {/* Right side — icon-only when iconOnly is set (Close/Discard), or primary text otherwise */}
        <div>
          {dashboardEvents
            ?.filter(x => !x.isLeft)
            ?.map((item, idx) => {
              const isIconOnly = !!item.iconOnly;
              return (
                <div
                  key={`r-${idx}`}
                  onClick={item.onClick}
                  className={isIconOnly ? css.actionIconOnly : css.actionPrimary}
                  title={isIconOnly ? item.name : undefined}
                >
                  <FontAwesomeIcon icon={item.icon} /> {!isIconOnly && item.name}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
}
